var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddToBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1000",
    "data-name": "Group 1000",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.273,
    height: 35.273,
    viewBox: "0 0 35.273 35.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12905",
    "data-name": "Path 12905",
    d: "M35.273,17.637A17.637,17.637,0,1,1,17.637,0,17.637,17.637,0,0,1,35.273,17.637",
    fill: "#ff005e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12906",
    "data-name": "Path 12906",
    d: "M21.1,14.619v1.8H19.3a.566.566,0,0,0,0,1.131h1.8v1.8a.566.566,0,1,0,1.132,0v-1.8h1.8a.566.566,0,1,0,0-1.131h-1.8v-1.8a.566.566,0,0,0-1.132,0",
    transform: "translate(3.293 2.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12907",
    "data-name": "Path 12907",
    d: "M28.664,18.558a4.777,4.777,0,0,0-2.454-4.17L26.081,12.8a2.676,2.676,0,0,0-2.729-2.571h-.674V7.824a2.733,2.733,0,0,0-2.73-2.731H13.156a2.734,2.734,0,0,0-2.73,2.731v2.408H9.753A2.676,2.676,0,0,0,7.024,12.8L6.09,24.212l0,.066a2.673,2.673,0,0,0,2.73,2.606H24.288a2.672,2.672,0,0,0,2.729-2.606l-.159-1.984a4.769,4.769,0,0,0,1.806-3.737m-1.132,0a3.644,3.644,0,1,1-3.644-3.644,3.648,3.648,0,0,1,3.644,3.644M12.078,7.824a1.081,1.081,0,0,1,1.078-1.079h6.792a1.08,1.08,0,0,1,1.078,1.079v2.408H12.078Zm13.34,16.481a1.08,1.08,0,0,1-1.13.979H8.816a1.08,1.08,0,0,1-1.13-.979L8.62,12.9l0-.065a1.075,1.075,0,0,1,1.13-1.008h1.295a.841.841,0,0,0,.2.026.824.824,0,0,0,.2-.026H21.648a.841.841,0,0,0,.2.026.824.824,0,0,0,.2-.026h1.3a1.075,1.075,0,0,1,1.13,1.008l.08.991a4.721,4.721,0,0,0-.674-.049,4.776,4.776,0,1,0,1.432,9.332Z",
    transform: "translate(1.07 0.895)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddToBag);
export default __webpack_public_path__ + "static/media/icon-add-to-bag.16107060e74b73fb3de652291218aac0.svg";
export { ForwardRef as ReactComponent };